export const DEBUG_PRINT_EDGES = false;

export const DEBUG_SHOW_NODE_IDS = false;
export const DEBUG_PRINT_DETAILED_COOK_INFO = false;
export const DEBUG_ALLOW_DIVING_INTO_PROC_ASSETS = false;
export const DEBUG_SHOW_FULL_MESH_NAMES_IN_HOVER = false;

export let ENABLE_CACHING = true;

export const ENABLE_FILE_NONE = true;

export function setEnableCaching(bValue)
{
	ENABLE_CACHING = bValue;
}